module.exports = __webpack_public_path__ + "static/media/spinner.f8e385a1.svg";